import { render } from "./foto-16.vue?vue&type=template&id=2c7a31a6&scoped=true"
import script from "./foto-16.vue?vue&type=script&lang=js"
export * from "./foto-16.vue?vue&type=script&lang=js"

import "./foto-16.vue?vue&type=style&index=0&id=2c7a31a6&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a31a6"]])

export default __exports__